import React from "react";
import RoutesChild from "./routesChild";
import IdealTimeoutHooks from "../components/IdealTimeoutHooks";
class Routes extends React.Component {
  render() {
    return (
      <>
        <IdealTimeoutHooks />
        <RoutesChild />
      </>
    );
  }
}

export default Routes;
